import './_body-view-height';
import './_scroll-to.js';
import './header';
import './_search';
//import './_lazy-image.js';
//import './_slideshow.js';
import './_tutorials.js';
import './_skip-header.js';
import './_get-posts.js';
import './_map.js';
import './_custom-dashboard.js';
import './_numbering-statements.js';

$('button.print-btn').click(function() {
  window.print();
});
import './_archive-uttalelser.js';
import './_archive-besoksrapporter.js';
import './_language-switcher.js';
import './_table-of-contents.js';
import './_accordions.js';
import './_archive.js';
import './_reports-listing.js';
import './_form.js';
import './_tooltip.js';